export default "/images/9.png?98e3ff20a60ea0efe4360f0a2cc9ae8a";